export const HEALTH_ITEMS = [
  { field: 'utilizaMedicacao', label: 'Utiliza medicação', summary: 'Utiliza medicacao', detail: 'medicacaoQual', detailLabel: 'Qual medicação?', prefix: 'Medicacao' },
  { field: 'doencaCongenita', label: 'Doença congênita', summary: 'Doenca congenita', detail: 'doencaCongenitaQual', detailLabel: 'Qual doença?', prefix: 'Tipo' },
  { field: 'hipertensao', label: 'Hipertensão', summary: 'Hipertensao' },
  { field: 'epilepsia', label: 'Epilepsia', summary: 'Epilepsia', treatment: 'epilepsiaTratamento', prefix: 'Tratamento' },
  { field: 'hemofilia', label: 'Hemofilia', summary: 'Hemofilia' },
  { field: 'diabetes', label: 'Diabetes', summary: 'Diabetes', treatment: 'diabetesTratamento', prefix: 'Tratamento' },
  { field: 'asma', label: 'Asma', summary: 'Asma' },
  { field: 'alergiaSubstancia', label: 'Alergia a substâncias ou medicamentos', description: 'Inclui medicamentos tópicos, orais e injetáveis.', summary: 'Alergia a substancia', detail: 'alergiaSubstanciaQual', detailLabel: 'Quais substâncias ou medicamentos?', prefix: 'Substancia' },
  { field: 'alergiaAlimentar', label: 'Alergia alimentar', summary: 'Alergia alimentar', detail: 'alergiaAlimentarQual', detailLabel: 'Quais alimentos?', prefix: 'Alimento' },
  { field: 'planoSaude', label: 'Possui plano de saúde', summary: 'Possui plano de saude', detail: 'planoSaudeQual', detailLabel: 'Qual plano?', prefix: 'Plano' },
  { field: 'acompanhamentoEspecialista', label: 'Acompanhamento com especialista', summary: 'Acompanhamento com especialista', detail: 'acompanhamentoEspecialistaQual', detailLabel: 'Qual especialista?', prefix: 'Especialista' },
];

export const getHealthDetailIssues = form => HEALTH_ITEMS.filter(item =>
  form[item.field] === 'sim' && item.detail && !String(form[item.detail] || '').trim(),
);
const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const parenthesized = value => {
  if (!value.trimStart().startsWith('(')) return '';
  const start = value.indexOf('(');
  let depth = 0;
  for (let i = start; i < value.length; i += 1) {
    if (value[i] === '(') depth += 1;
    if (value[i] === ')') depth -= 1;
    if (!depth) return value.slice(start + 1, i);
  }
  return value.slice(start + 1).trim();
};

// Recupera o resumo existente e conserva detalhes, inclusive parênteses internos.
export const readEnrollmentHealth = observation => {
  const text = String(observation || '').normalize('NFC');
  const normalizedText = normalize(text);
  const match = normalizedText.match(/(?:\*{3}\s*)?ASPECTOS DE SAUDE\s*(?:\*{3})?\s*([\s\S]*?)(?=\s*(?:\*{3}\s*)?(?:ASPECTO DE SAUDE HISTORICO|CONTATOS EMERGENCIA|AUTORIZACOES|DIREITO DE IMAGEM|FORMA DE PAGAMENTO|VENCIMENTO BOLETO|COR RACA)\b|$)/i);
  if (!match) return {};
  const start = match.index + match[0].length - match[1].length;
  const section = text.slice(start, start + match[1].length);
  const result = {};
  HEALTH_ITEMS.forEach(item => {
    const candidates = [...normalize(section).matchAll(new RegExp(`\\b${item.summary}\\b`, 'ig'))];
    const found = candidates.find(candidate => {
      let depth = 0;
      for (const character of section.slice(0, candidate.index)) {
        if (character === '(') depth += 1;
        if (character === ')') depth = Math.max(0, depth - 1);
      }
      return depth === 0;
    });
    if (!found) return;
    result[item.field] = 'sim';
    const detail = parenthesized(section.slice(found.index + found[0].length));
    if (item.detail && detail) result[item.detail] = detail.replace(new RegExp(`^${item.prefix}\\s*`, 'i'), '').trim();
    if (item.treatment && detail) result[item.treatment] = /Tratamento\s+sim/i.test(detail) ? 'sim' : 'nao';
  });
  return result;
};
